import React, { Component, useEffect, useState } from "react";
import Joi from "joi-browser";
import Form from "../comman/form";
import config from "../config.json";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginStep2 from "./Auth/LoginStep2";
import LoginStep1 from "./Auth/LoginStep1";
import ForgetPassword from "./ForgetPassword";
import LoginHeader from "./Auth/LoginHeader";
import LoginFooter from "./Auth/LoginFooter";
import { withMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, getLoggedUser, getLoginFailedStatus, loginFailed, sign, validateAdUser } from "../app/store/auth";
import {
  LOGIN_REQUEST,
  PUBLIC_CLIENT_APPLICATION,
  TOKEN_REQUEST,
} from "../msalConfig";

const AdminLogin = () => {

  const [validId, setValidId] = useState("");
  const [userName, setUserName] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [stateErrors, setStateErrors] = useState("");
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [loginBy, setLoginBy] = useState(null);
  const [interactionInProgress, setInteractionInProgress] = useState(false);

  const usrType = localStorage.getItem("userType");

  const loggedUserSeletor = useSelector(getLoggedUser);
  const loginFailedStatusSelector = useSelector(getLoginFailedStatus);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    const state = location.state;
    if (state?.validId) {
      setValidId(state.validId);
    }
  }, []);

  useEffect(() => {
    if (
      loggedUserSeletor.user &&
      !loggedUserSeletor.token &&
      loginBy !== "ad"
    ) {
      localStorage.setItem("tempPwd", userPwd);
      navigate("/ValidateUser");
    } else {
      if (currentUser) {
        setInteractionInProgress(false);
        navigate("/");
      }
    }
    if (currentUser) {
      setInteractionInProgress(false);
      navigate("/");
    }
  }, [loggedUserSeletor]);

  useEffect(() => {
    if (loginFailedStatusSelector !== "") {
      setStateErrors("Username or password is incorrect");
      dispatch(loginFailed(""))
    }
  }, [loginFailedStatusSelector])

  const handleStep1 = (step1Data) => {
    if (step1Data?.validId) {
      setStep1(false);
      setStep2(true);
      setValidId(step1Data.validId);
    }
  };

  const doSubmit = async (step2Data) => {
    dispatch(sign(step2Data.username, step2Data.password));
    setUserName(step2Data.username);
    setUserPwd(step2Data.password);
  };

  const handleBack = () => {
    setStep1(true);
    setStep2(false);
    setValidId("");
    localStorage.removeItem("userType");
  };

  const handleForgotPwd = () => {
    navigate("/ForgotPassword", { state: { validId } });
  }

  const handleSignIn = async () => {
    try {
      setInteractionInProgress(true);
      const loginResponse = await PUBLIC_CLIENT_APPLICATION.loginPopup(
        LOGIN_REQUEST
      );
      if (loginResponse.account) {
        PUBLIC_CLIENT_APPLICATION.setActiveAccount(loginResponse.account);
      }
      const tokenResponse = await PUBLIC_CLIENT_APPLICATION.acquireTokenSilent(
        TOKEN_REQUEST
      );
      //localStorage.setItem("loginType", "ad");
      setLoginBy("ad");
      dispatch(validateAdUser(tokenResponse.uniqueId, tokenResponse.accessToken));
    } catch (error) {
      setInteractionInProgress(false);
      console.log(error);
    }
  };

  return (
    <React.Fragment>
      {step1 && (
        <div className="login-page">
          <div className="login-shell">
            <div className="login-top-banner">
              <i className="fa fa-shield" aria-hidden="true"></i>
              <span>Human Resources Information Management System (HRIMS)</span>
            </div>
            <section className="login-hero" aria-label="WorkFINITY platform overview">
              {/* <p className="login-kicker">Workbench portal — HR, contracts, time logs and invoicing</p> */}
              <h1>
                Secure access to WorkFINITY®
                <br />
                AI driven Platform
              </h1>
              <div className="login-highlights" aria-label="Portal capabilities">
                <span>Onboarding</span>
                <span>Contracts</span>
                <span>Time Logs</span>
                <span>Invoicing</span>
              </div>
            </section>

            <section className="login-panel" aria-label="Sign in">
              <div className="login-card">
                <div className="login-card-header">
                  <button
                    className="login-ms-btn"
                    onClick={handleSignIn}
                    disabled={interactionInProgress}
                  >
                    {interactionInProgress ? (
                      <i className="fa fa-circle-o-notch fa-spin mr-1"></i>
                    ) : (
                      <i className="fa fa-windows" style={{ color: "#00a1f1" }}></i>
                    )}
                    Sign In With Microsoft
                  </button>
                  <h2>Sign in</h2>
                </div>
                <LoginStep1
                  handleStep1={handleStep1}
                  userError={stateErrors}
                  type="admin"
                  handleAdLogin={handleSignIn}
                  interactionInProgress={interactionInProgress}
                  validId={validId}
                ></LoginStep1>
                <div className="mt-3 text-right">
                  <Link to="/ForgotValidID" className="login-link" style={{ border: "none", background: "none", boxShadow: "none", textDecoration: "none" }}>
                    Forgot Your ID?
                  </Link>
                </div>
              </div>
            </section>
            <div className="login-saas-banner">
              <i className="fa fa-cloud" aria-hidden="true"></i>
              <span>
                SaaS platform hosted in Microsoft Azure Government Account - a FedRAMP certified cloud infrastructure
              </span>
            </div>
          </div>
        </div>
      )}

      {step2 && (
        <div className="login-page">
          <div className="login-shell">
            <div className="login-top-banner">
              <i className="fa fa-shield" aria-hidden="true"></i>
              <span>Human Resources Information Management System (HRIMS)</span>
            </div>
            <section className="login-hero" aria-label="Selected account context">
              <div className="login-hero-centered-copy">
                <h1>Welcome back</h1>
                <p className="login-copy">
                  Complete secure access using your username and password.
                </p>
                <div className="login-highlights" aria-label="Portal capabilities">
                  <span>Onboarding</span>
                  <span>Contracts</span>
                  <span>Time Logs</span>
                  <span>Invoicing</span>
                </div>
              </div>
              <div className="login-hero-account">
                <div>
                  <span>User Type</span>
                  <span><strong>{usrType}</strong></span>
                </div>
                <div>
                  <span>Valid ID</span>
                  <strong>{validId}</strong>
                </div>
              </div>
            </section>

            <section className="login-panel" aria-label="Sign in credentials">
              <div className="login-card">
                <div className="login-card-header">
                  <button className="login-back" onClick={handleBack}>
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    Back
                  </button>
                  <h2>Sign in</h2>
                </div>
                <LoginStep2
                  handleDoSubmit={doSubmit}
                  userError={stateErrors}
                  handleForgotPwd={handleForgotPwd}
                  type="admin"
                ></LoginStep2>

              </div>
            </section>
            <div className="login-saas-banner">
              <i className="fa fa-cloud" aria-hidden="true"></i>
              <span>
                SaaS platform hosted in Microsoft Azure Government Account - a FedRAMP certified cloud infrastructure
              </span>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default withMsal(AdminLogin);
